export default "__VITE_ASSET__7e1de5e7__"